import React from "react";
import "./whitesection.css";
import Generalprocess from "../Generalprocess/Generalprocess";
import Proficient from "../Proficient/Proficient";
import Testimonial from "../../../Components/Testomonial/Testomonial";
import Contactpage from "../../Contactpage/Contactpage";

const Whitesection = () => {
  return (
    <div className="white-section-container">
      <Generalprocess />
      <Proficient />
      <div
        className="mainContainer"
        style={{
          minWidth: "85%",
          background: "#253578",
          borderRadius: "12px",
          height: "400px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Testimonial />
      </div>
      <div style={{ paddingTop: "2rem", paddingBottom: "2rem" }}>
        <Contactpage />
      </div>
    </div>
  );
};

export default Whitesection;
